import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { Organization } from '@/types';
import { useDeleteOrganizationMutation } from '@/services';

export interface DeleteOrganizationProps extends DialogProps {
  organization: Organization;
  onClose(): void;
}

const DeleteOrganization: React.FC<DeleteOrganizationProps> = ({ organization, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteOrganization, deleteOrganizationResponse] = useDeleteOrganizationMutation();

  async function handleDeleteOrganization() {
    try {
      await deleteOrganization(organization).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{organization?.full_name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{organization?.full_name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button color="secondary" variant="outlined" disabled={deleteOrganizationResponse.isLoading} onClick={onClose}>
          Закрыть
        </Button>

        <Button variant="contained" disabled={deleteOrganizationResponse.isLoading} onClick={handleDeleteOrganization}>
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteOrganization;
